import { colors } from '../styles/colors';

type Edit5IconProps = {
  color?: string;
  size?: string;
}

export const Edit5Icon = ({ size = '14', color = colors.White }: Edit5IconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4861_3737)">
      <path d="M6.41666 2.33334H3.96666C2.98656 2.33334 2.49652 2.33334 2.12217 2.52408C1.79289 2.69186 1.52517 2.95957 1.3574 3.28886C1.16666 3.6632 1.16666 4.15325 1.16666 5.13334V10.0333C1.16666 11.0134 1.16666 11.5035 1.3574 11.8778C1.52517 12.2071 1.79289 12.4748 2.12217 12.6426C2.49652 12.8333 2.98656 12.8333 3.96666 12.8333H8.86666C9.84675 12.8333 10.3368 12.8333 10.7111 12.6426C11.0404 12.4748 11.3081 12.2071 11.4759 11.8778C11.6667 11.5035 11.6667 11.0134 11.6667 10.0333V7.58334M4.66664 9.33334H5.64346C5.92881 9.33334 6.07149 9.33334 6.20576 9.3011C6.3248 9.27252 6.4386 9.22539 6.54299 9.16142C6.66072 9.08927 6.76161 8.98838 6.96339 8.7866L12.5417 3.20834C13.0249 2.72509 13.0249 1.94159 12.5417 1.45834C12.0584 0.97509 11.2749 0.975089 10.7917 1.45834L5.21338 7.0366C5.0116 7.23838 4.91071 7.33927 4.83856 7.45701C4.77459 7.56139 4.72746 7.67519 4.69888 7.79424C4.66664 7.9285 4.66664 8.07118 4.66664 8.35654V9.33334Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_4861_3737">
        <rect width="14" height="14" fill={color} />
      </clipPath>
    </defs>
  </svg>
);
